export default __webpack_public_path__ + "static/media/1.ec8c1a18.jpg";